import { adminHttpClient } from '../commons/adminHttpClient'
import { Moment } from 'moment'

export interface LegalDocumentContentValues {
  benefitStartDate: Moment
  primaryAdminFirstName: string
  primaryAdminLastName: string
  primaryAdminEmail: string
  legalDocumentsContentHtml: string
}

export const getLegalDocuments = (): Promise<any> => {
  return adminHttpClient.get('/EESignup/LegalDocuments')
}

export const finishSignupApi = (): Promise<any> => {
  return adminHttpClient.post('/EESignup/FinishSignup', {})
}

export const completeSpecialOffer = (): Promise<any> => {
  return adminHttpClient.post('/EESignup/CompleteSpecialOffer', {})
}

export const isLegalDocumentLastStep = (): Promise<boolean> => {
  return adminHttpClient.get('/IsLegalDocumentLastStep')
}

export const SendOfferEmail = (): Promise<any> => {
  return adminHttpClient.post('/SendOfferEmail', {})
}

export default finishSignupApi
